import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface NeedRefreshesState {
  /** メッセージ送信(家族・施設関係者) */
  sendMessage: SendMessagesState;
  /** 待機者一覧 */
  waiterList: WaiterListState;
  /** メッセージ送信(待機者) */
  sendWaiterMessage: SendWaiterMessagesState;
  /** 利用者一覧 */
  residentList: ResidentListState;
  /** 家族ユーザー一覧 */
  familyList: FamilyListState;
  /** 施設関係者一覧 */
  otherUserGroupList: OtherUserGroupListState;
  /** 宛先グループ一覧 */
  sendMessageGroupList: SendMessageGroupListState;
  /** カレンダー・履歴 */
  report: ReportState;
  /** イベント一覧 */
  eventList: EventListState;
}

export interface SendMessagesState {
  /** 新規送信タブ */
  sendMessages: boolean;
  /** 下書き一覧タブ */
  draftMessages: boolean;
  /** 履歴（家族）タブ */
  familyHistories: boolean;
  /** 履歴（施設関係者）タブ */
  otherUserHistories: boolean;
}

export interface WaiterListState {
  /** 待機者一覧 */
  waiterList: boolean;
}

export interface SendWaiterMessagesState {
  /** 新規送信タブ */
  sendMessages: boolean;
}

export interface ResidentListState {
  /** 利用者一覧 */
  residentList: boolean;
}

export interface FamilyListState {
  /** 家族ユーザー一覧 */
  familyList: boolean;
}

export interface OtherUserGroupListState {
  /** 施設関係者一覧 */
  otherUserGroupList: boolean;
}

export interface SendMessageGroupListState {
  /** 宛先グループ一覧 */
  sendMessageGroupList: boolean;
}

export interface ReportState {
  /** カレンダー・履歴 */
  report: boolean;
}

export interface EventListState {
  /** イベント一覧 */
  eventList: boolean;
}

/**
 * ### NeedRefreshes store
 */
@Module({ name: "needRefreshes" })
export default class NeedRefreshes extends VuexModule implements NeedRefreshesState {
  /** メッセージ送信(家族・施設関係者) */
  sendMessage = {
    /** 新規送信タブ */
    sendMessages: false,
    /** 下書き一覧タブ */
    draftMessages: false,
    /** 履歴（家族）タブ */
    familyHistories: false,
    /** 履歴（施設関係者）タブ */
    otherUserHistories: false
  };
  /** 待機者一覧 */
  waiterList = {
    /** 待機者一覧 */
    waiterList: false
  };
  /** メッセージ送信(待機者) */
  sendWaiterMessage = {
    /** 新規送信タブ */
    sendMessages: false
  };
  /** 利用者一覧 */
  residentList = {
    /** 利用者一覧 */
    residentList: false
  };
  /** 家族ユーザー一覧 */
  familyList = {
    /** 家族ユーザー一覧 */
    familyList: false
  };
  /** 施設関係者一覧 */
  otherUserGroupList = {
    /** 施設関係者一覧 */
    otherUserGroupList: false
  };
  /** 宛先グループ一覧 */
  sendMessageGroupList = {
    /** 宛先グループ一覧 */
    sendMessageGroupList: false
  };
  /** カレンダー・履歴 */
  report = {
    /** カレンダー・履歴 */
    report: false
  };
  /** イベント一覧 */
  eventList = {
    /** イベント一覧 */
    eventList: false
  };

  @Mutation
  private INITIALIZE_NEED_REFRESHES(): void {
    this.sendMessage = {
      sendMessages: false,
      draftMessages: false,
      familyHistories: false,
      otherUserHistories: false
    };
    this.waiterList = {
      waiterList: false
    };
    this.sendWaiterMessage = {
      sendMessages: false
    };
    this.residentList = {
      residentList: false
    };
    this.familyList = {
      familyList: false
    };
    this.otherUserGroupList = {
      otherUserGroupList: false
    };
    this.sendMessageGroupList = {
      sendMessageGroupList: false
    };
    this.report = {
      report: false
    };
    this.eventList = {
      eventList: false
    };

    return;
  }

  @Mutation
  private SET_SEND_MESSAGE(sendMessage: SendMessagesState): void {
    this.sendMessage = sendMessage;
    return;
  }

  @Mutation
  private SET_WAITER_LIST(waiterList: WaiterListState): void {
    this.waiterList = waiterList;
    return;
  }

  @Mutation
  private SET_SEND_WAITER_MESSAGE(sendWaiterMessage: SendWaiterMessagesState): void {
    this.sendWaiterMessage = sendWaiterMessage;
    return;
  }

  @Mutation
  private SET_RESIDENT_LIST(residentList: ResidentListState): void {
    this.residentList = residentList;
    return;
  }

  @Mutation
  private SET_FAMILY_LIST(familyList: FamilyListState): void {
    this.familyList = familyList;
    return;
  }

  @Mutation
  private SET_OTHER_USER_GROUP_LIST(otherUserGroupList: OtherUserGroupListState): void {
    this.otherUserGroupList = otherUserGroupList;
    return;
  }

  @Mutation
  private SET_SEND_MESSAGE_GROUP_LIST(sendMessageGroupList: SendMessageGroupListState): void {
    this.sendMessageGroupList = sendMessageGroupList;
    return;
  }

  @Mutation
  private SET_REPORT(report: ReportState): void {
    this.report = report;
    return;
  }

  @Mutation
  private SET_EVENT_LIST(eventList: EventListState): void {
    this.eventList = eventList;
    return;
  }

  /**
   * ### 初期化
   */
  @Action({ rawError: true })
  public async initializeNeedRefreshes(): Promise<void> {
    this.INITIALIZE_NEED_REFRESHES();
    return;
  }

  @Action({ rawError: true })
  public async setSendMessage(payload: SendMessagesState): Promise<void> {
    this.SET_SEND_MESSAGE(payload);
    return;
  }

  @Action({ rawError: true })
  public async setWaiterList(payload: WaiterListState): Promise<void> {
    this.SET_WAITER_LIST(payload);
    return;
  }

  @Action({ rawError: true })
  public async setSendWaiterMessage(payload: SendWaiterMessagesState): Promise<void> {
    this.SET_SEND_WAITER_MESSAGE(payload);
    return;
  }

  @Action({ rawError: true })
  public async setResidentList(payload: ResidentListState): Promise<void> {
    this.SET_RESIDENT_LIST(payload);
    return;
  }

  @Action({ rawError: true })
  public async setFamilyList(payload: FamilyListState): Promise<void> {
    this.SET_FAMILY_LIST(payload);
    return;
  }

  @Action({ rawError: true })
  public async setOtherUserGroupList(payload: OtherUserGroupListState): Promise<void> {
    this.SET_OTHER_USER_GROUP_LIST(payload);
    return;
  }

  @Action({ rawError: true })
  public async setSendMessageGroupList(payload: SendMessageGroupListState): Promise<void> {
    this.SET_SEND_MESSAGE_GROUP_LIST(payload);
    return;
  }

  @Action({ rawError: true })
  public async setReport(payload: ReportState): Promise<void> {
    this.SET_REPORT(payload);
    return;
  }

  @Action({ rawError: true })
  public async setEventList(payload: EventListState): Promise<void> {
    this.SET_EVENT_LIST(payload);
    return;
  }
}
